import React, { useEffect, useState } from "react";
import { Popup } from "@progress/kendo-react-popup";
import useOnClickOutside from "use-onclickoutside";
import { number } from "../../config";
import { usePopup } from "../../helper/commonHooks";
import "./drutasDropdown.scss";

/**
 * used to render the search bar for selection custom components in filter popup
 * @param {*} props
 * @author {Sarthak Arora}
 */
export const DrutasDropdownFlowElements = React.memo((props) => {
  const { value, onChange, data, label, key, className, popupClass, isfilter, filterContent, itemRender, valueRender, disabled, clearFilterText } =
    props;

  const {
    show: isPopupOpen,
    setShow: setIsPopupOpen,
    anchor: dynamicSearchRef,
    contentRef: removeWorkflowRef,
    blurTimeoutRef,
    onOpen,
    onFocus,
    onBlur,
  } = usePopup();

  const [popupWidthPx, setPopupWidthPx] = useState(null);

  /** Clear measured width when the popup closes (selection, outside click, toggle). */
  useEffect(() => {
    if (!isPopupOpen) {
      setPopupWidthPx(null);
    }
  }, [isPopupOpen]);

  useOnClickOutside(removeWorkflowRef, (e) => {
    if (e.target.closest(".drutas-dropdown-value-container")) return;
    setIsPopupOpen(false);
  });

  const togglePopup = () => {
    if (disabled) return;
    if (!isPopupOpen === false) clearFilterText();
    if (isPopupOpen) {
      setIsPopupOpen(false);
    } else {
      const w = dynamicSearchRef.current?.offsetWidth;
      setPopupWidthPx(w && w > number.ZERO ? w : null);
      setIsPopupOpen(true);
    }
  };

  const handleOnClick = (item) => {
    // Clear any pending blur timeout to prevent popup from closing
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current);
    }
    onChange(item);
    setIsPopupOpen(false);
  };

  const hideOnBlur = () => {
    setIsPopupOpen(false);
  };

  // Prevent blur when clicking on dropdown elements
  const handleElementMouseDown = (e) => {
    // Prevent event bubbling and default behavior
    e.preventDefault();
    e.stopPropagation();
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current);
    }
  };

  /**handles popup on open*/
  const handleOnOpen = () => {
    onOpen(removeWorkflowRef);
  };

  /**handles popup on focus */
  const handleOnFocus = () => {
    onFocus(blurTimeoutRef);
  };

  const handleOnBlur = () => {
    onBlur(blurTimeoutRef, hideOnBlur);
  };

  return (
    <div ref={dynamicSearchRef} className={`drutas-dropdown-container ${className ? className : ""}`}>
      <div className='drutas-dropdown-value-container'>
        <div onClick={togglePopup} className={`truncate-text ${!disabled ? "cursor-pointer" : ""}`}>
          {valueRender ? valueRender(value) : value ? value[label] : "select"}
        </div>
      </div>
      {isPopupOpen && (
        <div>
          <Popup
            collision={{
              horizontal: 'fit',
              vertical: 'none'
            }}
            show={isPopupOpen}
            animate={false}
            anchor={dynamicSearchRef.current}
            className={""}
            popupClass={`${popupClass ? popupClass : ""}`}
            onOpen={handleOnOpen}
            style={popupWidthPx != null ? { width: popupWidthPx, maxWidth: popupWidthPx, boxSizing: "border-box"} : undefined}>
            <div
              ref={removeWorkflowRef}
              className={`drutas-dropdown-popup-flow-elemets`}
              tabIndex={number.ZERO}>
              {isfilter && filterContent()}
              {data && !!data.length ? (
                <div className='drutas-dropdown-popup-elements'>
                  {data?.map((item) => {
                    return itemRender ? (
                      itemRender(item, handleOnClick, handleElementMouseDown)
                    ) : (
                      <span
                        className='drutas-dropdown-popup-element truncate-text'
                        key={item[key]}
                        onMouseDown={handleElementMouseDown}
                        onClick={() => handleOnClick(item)}>
                        {item[label]}
                      </span>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center">No data Item</div>
              )}
            </div>
          </Popup>
        </div>
      )}
    </div>
  );
});